import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EventGroup = /*#__PURE__*/function () {
  function EventGroup() {
    _classCallCheck(this, EventGroup);
    _defineProperty(this, "decorators", []);
  }
  _createClass(EventGroup, [{
    key: "addEvent",
    value: function addEvent(eventId, eventData) {
      var _this = this;
      var defaultEventDataConstructor = function defaultEventDataConstructor(args) {
        return _objectSpread({}, args);
      };
      return function (args) {
        return {
          eventId: eventId,
          groupId: _this.groupId,
          groupVersion: _this.groupVersion,
          eventData: _this.decorators.reduce(function (previous, current) {
            return current(previous);
          }, eventData || defaultEventDataConstructor).bind(undefined, args)
        };
      };
    }
  }]);
  return EventGroup;
}();

export { EventGroup };
